import React, {useEffect, useState} from 'react';
import RolePageTable from './rolePageTable';

const Roles = (props) => {

  return (
      <RolePageTable></RolePageTable>
  );
}

export default Roles;